interface AvatarProps {
  user: { displayName: string; initials: string };
  /** Size modifier from the design, e.g. `profile-image-md`. */
  sizeClass?: string;
  /** Typography applied to the initials fallback. */
  initialsClass?: string;
}

/** The user's initials on the primary fill — the badge shown throughout the app. */
export function Avatar({ user, sizeClass = '', initialsClass = 'fw-bold' }: AvatarProps) {
  const shape = ['profile-image', sizeClass, 'rounded-circle'].filter(Boolean).join(' ');

  return (
    <div
      className={`${shape} bg-primary text-white d-flex align-items-center justify-content-center`}
      aria-label={user.displayName}
    >
      <span className={initialsClass}>{user.initials}</span>
    </div>
  );
}
